import { render, staticRenderFns } from "./PerformanceManagement.vue?vue&type=template&id=3d038c8c&scoped=true&"
import script from "./PerformanceManagement.vue?vue&type=script&lang=ts&"
export * from "./PerformanceManagement.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceManagement.vue?vue&type=style&index=0&id=3d038c8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d038c8c",
  null
  
)

export default component.exports